var tp_menu_mobile = (function () {
  return {
    init: function () {
      this.toggle_menu_mobile();
    },
    toggle_menu_mobile: function () {
      document.addEventListener('click', (e) => {
        const el = e.target;
        if (!el || !el.closest) return;
        if (!el.closest('.header-mobile') && !el.closest('.toggle-nav')) return;
        this.handleClickMenuHeader2(el);
        this.handleMenuNormal(e);
      }, { passive: true });
    },
    handleMenuNormal: function (e) {
      const toggle_nav = e.target.classList.contains('toggle-nav');
      //toggle menu mobile
      if (toggle_nav) {
        e.target.closest('.header-mobile').querySelector('.col-header-center')?.classList.add('open-header-menu')
      }
      if (!e.target.closest('.col-header-center') && !toggle_nav || e.target.classList.contains('close-hd-mobile')) {
        const menu_mobile = document.querySelector('.col-header-center')
        menu_mobile.classList.remove('open-header-menu')
      }

      //click menu livel 0
      const level0 = e.target.classList.contains('level0');
      if (level0) {
        const sub_menu_lv2 = e.target.querySelector('.mega-demo-sub')
        if (sub_menu_lv2) {
          sub_menu_lv2.classList.add('open-header-menu-sub')
        }
      }
      if (e.target.classList.contains('back-hd-mobile')) {
        e.target.parentNode.classList.remove('open-header-menu-sub')
      }

      //click menu level 1
      const menuLinkLv1 = e.target.closest('.menu-link-lv1');
      if (menuLinkLv1) {
        const sub_menu_lv2 = menuLinkLv1.querySelector('.dropdown-child');
        if (sub_menu_lv2) {
          sub_menu_lv2.classList.add('open-header-menu-sub2');
        }
      }
      if (e.target.classList.contains('back-hd-mobile')) {
        e.target.parentNode.classList.remove('open-header-menu-sub2')
      }
    },
    handleClickMenuHeader2: function (el) {
      //click seclect menu Category or menu normal belong to Header layout 2     
      const btn_select_menu = el.classList.contains('select-menu-mobile');
      if (!btn_select_menu) return;
      const parent = el.closest('.col-header-center');
      const menuMobiles = document.querySelectorAll('.menu-mobile');
      parent.querySelector('.select-menu-mobile.active').classList.remove('active');
      el.classList.add('active');
      menuMobiles.forEach(function (menuItem) {
        if (menuItem.classList.contains('mobile-active')) {
          menuItem.classList.remove('mobile-active')
        } else {
          menuItem.classList.add('mobile-active')
        }
      })
      const mnCateLv1 = el.classList.contains('.mn-cate-lv1');
      if (mnCateLv1) {
        mnCateLv1.querySelector('.sub-menu-category').classList.add('open');
      }
    }
  };
})();
tp_menu_mobile.init();

var tpHeaderProduct = new Swiper('.tp-header-product', {
  slidesPerView: 1,
  spaceBetween: 0,
  autoplay: true,
  loop: true,
  pagination: {
    clickable: true,
    el: ".swiper-pagination-hd-prd",
  },
});

class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.hdLayout2 = document.querySelector('.header-2-home-page');
    this.menuCate = this.hdLayout2?.querySelector('.mn-cate');
  }

  connectedCallback() {
    this.header = document.querySelector('.section-header');
    this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
    this.headerBounds = {};
    this.isCartPage =
      document.body.classList.contains('template-cart') ||
      window.location.pathname.replace(/\/$/, '') === '/cart';

    this.setHeaderHeight();

    window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

    if (this.headerIsAlwaysSticky) {
      this.header.classList.add('shopify-section-header-sticky');
    };

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.header);
  }

  onScroll() {
    if (this.isCartPage) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.menuCate?.classList.contains('is-home')) {
        this.menuCate.classList.remove('is-home');
      }

      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add('scrolled-past-header');
      if (this.menuCate?.classList.contains('is-home')) {
        this.menuCate.classList.remove('is-home');
      }
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove('scrolled-past-header');
      this.menuCate?.classList.add('is-home');
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    this.closeMenuDisclosure();
    this.closeSearchModal();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add('shopify-section-header-sticky', 'animate');
    this.header.classList.remove('shopify-section-header-hidden');
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
    this.disclosures.forEach(disclosure => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    this.searchModal.close(false);
  }
}
customElements.define('sticky-header', StickyHeader);


// Mega Menu - Collection
document.addEventListener('DOMContentLoaded', () => {
  const tabs = document.querySelectorAll('.menu-collection-tab');
  const panels = document.querySelectorAll('.menu-collection-products');

  if (!tabs.length || !panels.length) return;

  const activate = (handle, tab) => {
    tabs.forEach(t => t.classList.remove('is-active'));
    panels.forEach(p => p.classList.remove('is-active'));

    tab.classList.add('is-active');

    const panel = document.querySelector(
      `.menu-collection-products[data-collection="${handle}"]`
    );

    if (panel) panel.classList.add('is-active');
  };

  tabs.forEach(tab => {
    const handle = tab.dataset.collection;

    // Desktop hover
    tab.addEventListener('mouseenter', () => {
      if (window.innerWidth >= 1024) {
        activate(handle, tab);
      }
    });

    // Mobile click
    tab.addEventListener('click', e => {
      if (window.innerWidth < 1024) {
        e.preventDefault();
        activate(handle, tab);
      }
    });
  });
});